const normalizeDigits = (value) =>
	String(value ?? '')
		.replace(/[\u06f0-\u06f9]/g, (digit) => String(digit.charCodeAt(0) - 0x06f0))
		.replace(/[\u0660-\u0669]/g, (digit) => String(digit.charCodeAt(0) - 0x0660));

function isNumber(value) {
	return /^[0-9]+$/.test(normalizeDigits(value));
}

const nationalCodeDefaultError = 'کد ملی معتبر نیست ';

const persianCharacter = (value) => {
	const pattern = /^[\u0600-\u06FF\s]+$/;
	return pattern.test(value) || 'لطفا اطلاعات را به فارسی وارد نمایید';
};

const phoneNumber = (value) => {
	const phoneRegex = /^(\+98|0098|0|98|\+|'')?9\d{9}$/;
	return phoneRegex.test(normalizeDigits(value)) || 'شماره تلفن معتبر نیست';
};

const displayPhoneNumber = (value) => {
	if (!value) return true;
	const normalized = String(value)
		.trim()
		.replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 1776))
		.replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 1632))
		.replace(/[\s()-]/g, '');
	return /^\+?\d{10,15}$/.test(normalized) || 'شماره همراه یا تلفن معتبر نیست';
};

const noPersianNumber = (value) => {
	if (!value) return true;
	return /^[0-9]+$/.test(normalizeDigits(value)) || 'مقدار وارد شده باید عددی باشد.';
};

const confirmPassword = (value, [target]) => (value === target ? true : 'تکرار کلمه عبور باید مطابقت داشته باشد');

const checkFileSize = (files, [maxSize]) => {
	if (files) {
		for (let i = 0; i < files.length; i++) {
			if (files[i].size > maxSize * 1024) return `حجم فایل باید کمتر از ${maxSize} کیلوبایت باشد `;
		}
	}
	return true;
};

const acceptFileTypes = (files, [...allowedExtensions], ctx) => {
	const allowedExtensionsString = allowedExtensions.join(' یا ');
	if (typeof files === 'object' && files) {
		for (let i = 0; i < files.length; i++) {
			const fileExtension = files[i].type.split('/')[1];
			if (!allowedExtensions.includes(fileExtension)) return `پسوند فایل مورد نظر باید ${allowedExtensionsString} باشد`;
		}
	}
	if (typeof files === 'string') return true;
	return true;
};

const checkDimensions = async (files, [dimensions]) => {
	for (let i = 0; i < files.length; i++) {
		let img = new Image();
		img.src = URL.createObjectURL(files[i]);
		await img.decode();
		if (img.width >= +dimensions || img.height >= +dimensions) return `ابعاد فایل باید کمتر از ${dimensions} × ${dimensions} پیکسل باشد`;
	}
	return true;
};

const determineFileUploadMode = (files, [uploadMode]) => {
	if (uploadMode === 'multiple') {
		return true;
	}
	if (files.length > 1 && uploadMode === 'single') {
		return 'لطفا فقط یک فایل بارگذاری کنید ';
	}
	return true;
};

const customRequired = (values, [label]) => {
	const requiredDefaultError = `${label} الزامی است`;
	if (values === undefined || values === null) {
		return requiredDefaultError;
	}

	if (Array.isArray(values) && values.length === 0) {
		return requiredDefaultError;
	}

	if (typeof values === 'string' && values.trim() === '') {
		return requiredDefaultError;
	}

	return true;
};

const passwordEnglish = (value) => {
	const persianRegex = /[\u0600-\u06FF\u0750-\u077F\uFB50-\uFBCF\uFE70-\uFEFF]/;
	return persianRegex.test(value) ? 'لطفاً فقط از حروف انگلیسی استفاده کنید' : true;
};

const capitalAndLowerCharacters = (value) => {
	const characterRegex = /^(?=.*[a-z])(?=.*[A-Z])/;
	return characterRegex.test(value) ? true : 'capitalAndLowerCharacters';
};

const containNumber = (value) => {
	const characterRegex = /\d/;
	return characterRegex.test(value) ? true : 'containNumber';
};

const passwordMinLength = (value) => {
	return value.length >= 8 ? true : 'passwordMinLength';
};

const checkNumber = (value, [label]) => {
	return isNumber(value) ? true : `لطفا ${label} را به عدد وارد کنید`;
};

const numberReceipt = (value) => {
	const regex = /^[0-9\/\-.]*$/;
	return regex.test(normalizeDigits(value)) ? true : 'کاراکترهای مجاز - / .';
};

const sellUnitNumber = (value, [salableUnits]) => {
	if (value > salableUnits) {
		return 'تعداد واحد انتخابی نباید بیشتر از تعداد واحد قابل فروش باشد';
	}
	return true;
};

const validateRangeDate = (value, [target]) => {
	const currentDate = new Date(value);
	const targetDate = new Date(target);
	if (currentDate < targetDate) {
		return 'بازه زمانی انتخاب شده نادرست است.';
	}
	return true;
};

const maxValue = (value, [target], { label }) => {
	const valueToNumber = +value;
	if (valueToNumber > target) {
		const formattedTarget = Number(target).toLocaleString('fa-IR');
		return `${label} وارد شده نباید بیشتر از ${formattedTarget} باشد.`;
	}
	return true;
};

const minValue = (value, [target], { label }) => {
	const valueToNumber = +value;
	if (valueToNumber < target) {
		const formattedTarget = Number(target).toLocaleString('fa-IR');
		return `${label} وارد شده نباید کمتر از ${formattedTarget} باشد.`;
	}
	return true;
};

const bankCardNumber = (value) => {
	if (!value) return true;
	const cleaned = normalizeDigits(value).replace(/[\s-]/g, '');
	if (!/^\d+$/.test(cleaned)) {
		return 'شماره کارت باید فقط شامل ارقام باشد.';
	}
	if (cleaned.length !== 16) {
		return 'شماره کارت باید دقیقا ۱۶ رقم باشد.';
	}
	return true;
};

export default {
	maxValue,
	minValue,
	bankCardNumber,
	persianCharacter,
	phoneNumber,
	displayPhoneNumber,
	confirmPassword,
	passwordEnglish,
	capitalAndLowerCharacters,
	containNumber,
	noPersianNumber,
	passwordMinLength,
	checkFileSize,
	acceptFileTypes,
	customRequired,
	numberReceipt,
	determineFileUploadMode,
	sellUnitNumber,
	checkNumber,
	checkDimensions,
	validateRangeDate,
};
